import { store } from '../../store';
import { addChatMessage } from '../../store/slices/chatMessagesSlice';
import { updateIsActiveChatPanel, updateTotalUnreadChatMsgs, } from '../../store/slices/bottomIconsActivitySlice';
import { updateUnreadMsgFrom } from '../../store/slices/roomSettingsSlice';
import { DataMsgBodyType, } from '../proto/plugnmeet_datamessage_pb';
export const handleUserTypeData = (body, message_id, to) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (body.type === DataMsgBodyType.CHAT) {
        if (!body.messageId) {
            body.messageId = message_id;
        }
        const chatMsg = {
            type: 'CHAT',
            message_id: (_a = body.messageId) !== null && _a !== void 0 ? _a : '',
            time: (_b = body.time) !== null && _b !== void 0 ? _b : '',
            from: {
                sid: (_d = (_c = body.from) === null || _c === void 0 ? void 0 : _c.sid) !== null && _d !== void 0 ? _d : '',
                userId: (_f = (_e = body.from) === null || _e === void 0 ? void 0 : _e.userId) !== null && _f !== void 0 ? _f : '',
                name: (_g = body.from) === null || _g === void 0 ? void 0 : _g.name,
            },
            isPrivate: body.isPrivate === 1,
            msg: body.msg,
        };
        if (to) {
            chatMsg.to = to;
        }
        store.dispatch(addChatMessage(chatMsg));
        const isActiveChatPanel = store.getState().bottomIconsActivity.isActiveChatPanel;
        const selectedChatOption = store.getState().roomSettings.selectedChatOption;
        const currentUser = store.getState().session.currentUser;
        const isRecorder = (_h = ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === 'RECORDER_BOT' ||
            (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === 'RTMP_BOT')) !== null && _h !== void 0 ? _h : false;
        if (!isActiveChatPanel) {
            if (!isRecorder) {
                store.dispatch(updateTotalUnreadChatMsgs());
            }
            else {
                store.dispatch(updateIsActiveChatPanel(true));
            }
        }
        if (!body.isPrivate && selectedChatOption !== 'public') {
            store.dispatch(updateUnreadMsgFrom({
                task: 'ADD',
                id: 'public',
            }));
        }
        else if (body.isPrivate &&
            selectedChatOption !== ((_j = body.from) === null || _j === void 0 ? void 0 : _j.userId) &&
            ((_k = body.from) === null || _k === void 0 ? void 0 : _k.userId) !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)) {
            store.dispatch(updateUnreadMsgFrom({
                task: 'ADD',
                id: (_m = (_l = body.from) === null || _l === void 0 ? void 0 : _l.userId) !== null && _m !== void 0 ? _m : '',
            }));
        }
    }
};
